import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';

const ListZoneSuppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message,setMessage] = useState('');
  const {user,setUser} = useContext(UserContext);
  const navigate = useNavigate();

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getZoneSuppliers`, { withCredentials: true })
      .then(response => {
        const allSuppliers = response.data.data;
        setSuppliers(allSuppliers);
        console.log(allSuppliers);
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
      })
  }, []);

  
  const filteredSuppliers = suppliers.filter(supplier =>
    (supplier.name && supplier.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (supplier.company && supplier.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (supplier.address && supplier.address.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleSupplierClick = (supplier) => {
    navigate('/central/supplier-details', { state: { supplier } });
  };

  return (

    <div className="container-full p-4">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search Suppliers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredSuppliers.map(supplier => (
          <div
            key={supplier._id}
            onClick={() => handleSupplierClick(supplier)}
            className="p-4 bg-white rounded-lg shadow-md flex justify-between items-center cursor-pointer hover:bg-gray-100 transition-all duration-200 border-fmb-light border"
          >
            <div>
              <h3 className="text-xl font-semibold text-fmb">{supplier.company}</h3>
              <p className="text-sm text-gray-500">{supplier.address}</p>
            </div>
            <div className="text-fmb">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListZoneSuppliers;
